import InfoItem from "../../../components/InfoItem";

const TabDetail = (props) => {
  return (
    <div className="mt-6 flex flex-col gap-6">
      <div className={`flex flex-col border-b border-[#a2a1a833] gap-1 py-2`}>
        <strong className="text-[#A2A1A8] text-sm font-sf-light">
          Mô tả dịch vụ
        </strong>
        <span
          className="text-[#16151C]"
          dangerouslySetInnerHTML={{ __html: props.descripton }}
        ></span>
      </div>
      <InfoItem label="Ghi chú" value={props.note} />
    </div>
  );
};

export default TabDetail;
